import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Map from '../shared/components/Map';

import Geocoder from '../shared/components/Geocoder';

import { SAGA_CREATE_GEOFENCE } from './actions';

class GeofenceFindPOI extends Component {
  constructor(props){
    super(props);
    this.state = {
      location: {
        lat: '',
        lng: '',
      },
      formattedAddress: '',
      country: '',

    }
    this.createGeofence = this.createGeofence.bind(this);
  }

  createGeofence(){
    const geofenceBody = {
      geo: {
        type: 'Point',
        coordinates: [
          this.state.location.lng,
          this.state.location.lat,
        ],
      },
      formattedAddress: this.state.formattedAddress,
      country: this.state.country,
    };
    this.props.createGeofence(geofenceBody);
  }

  disableConfirmButton(){
    return this.state.location.lng.length === 0 
          || this.state.location.lat.length === 0 
          || this.state.formattedAddress.length === 0;
  }

  render() {
    const { state } = this;

    const center = (state.location.lat === '' || state.location.lng === '') ? null : state.location;

    return (
      <div>
        <div className="content-area">
          <div className="container">
            <h3 className="heading">Geofence Creation</h3>
            <h4 className="sub-heading" style={{ marginBottom: 26 }}>Find your Point Of Interest</h4>
            <div style={{ width: '100%', height: 400, paddingBottom: 42 }}>
              <Map drawMode={false} editMode={false} mapCenter={center} />
            </div>
          </div>
        </div>
        
        <div className="content-area" style={{ marginTop: 16 }}>
          <div className="container" style={{ paddingBottom: 40 }}>
            <div style={{ width: '50%', float: 'left' }}>
              <div className="form-field" style={{ width: '100%' }}>
                <Geocoder onResultSelect={(selected) => {
                  if (selected.location && selected.location.lat && selected.location.lng) {
                    this.setState({
                      location: selected.location,
                      formattedAddress: selected.formattedAddress,
                      country: selected.country,
                    });
                  }
                }} />
              </div>
              <div style={{ display: 'flex', width: '100%', flexDirection: 'row'}}>
                <div className="form-field" style={{ flexGrow: 1, marginRight: 20 }}>
                  <label>Longitude</label>
                  <input placeholder="" type="number" value={this.state.location.lng} onChange={()=>{

                  }} />
                </div>
                <div className="form-field" style={{ flexGrow: 1 }}>
                  <label>Latitude</label>
                  <input placeholder="" type="number" value={this.state.location.lat} onChange={()=>{

                  }} />
                </div>
              </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', width: 230, float: 'right' }}>
                <button className="btn btn-blue"
                        disabled={this.disableConfirmButton()}
                        style={{ flexGrow: 1 }} 
                        onClick={this.createGeofence}>Confirm Location</button>
            </div>
            <div style={{ clear: 'both' }}></div>
          </div>
        </div>
      </div>
    );
  }
}

GeofenceFindPOI.propTypes = {
  createGeofence: PropTypes.func,
};

// Map props to the store

const mapStateToProps = () => ({
});

const mapDispatchToProps = (dispatch) => ({
  createGeofence: (geofence) => {
    dispatch({
      type: SAGA_CREATE_GEOFENCE,
      payload: {
        geofence,
      },
    });
  },
})

const GeofenceFindPOIContainer = connect(mapStateToProps,mapDispatchToProps)(GeofenceFindPOI);

export default GeofenceFindPOIContainer;



// WEBPACK FOOTER //
// ./src/Geofence/GeofenceFindPOI.js